<select class="form-select form-select-sm"
        id="fieldAction"
        name="fieldAction"
        [ngModel]="selectedAction"
        (ngModelChange)="fieldActionChanged($event)"
        [disabled]="disabled">
    @for (pa of possibleActions; track pa) {
        <option [ngValue]="pa.value">{{ pa.name }}</option>
    }
</select>
